import { Flex, FlexProps, Grid } from '@chakra-ui/react';
import React, { useLayoutEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispath, BlockHeader } from 'shared';
import { LeadSmallSection } from 'features';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import {
    CateringEventFormatPageActions,
    useCateringEventFormatPageState,
} from '../../store';
import { CateringEventFormatPageMainCateringEventsList } from './CateringEventFormatPageMainCateringEventsList';

export type CateringEventFormatPageMainProps = FlexProps & React.RefAttributes<HTMLDivElement>

export const CateringEventFormatPageMain: React.FC<CateringEventFormatPageMainProps> = ({
    ...props
}) => {
    const { slug } = useParams();
    const dispatch = useAppDispath();
    const { cateringEventFormat, cateringEvents, leadFormPdf } = useCateringEventFormatPageState();

    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (slug) dispatch(CateringEventFormatPageActions.getCateringEventFormatBySlug({ slug }));
        if (slug) {
            dispatch(CateringEventFormatPageActions.getCateringEventsByFormatSlug({
                formatSlug: slug,
            }));
        }
    }, [slug]);

    return (
        <Flex
            flexDirection="column"
            ref={ref}
            {...props}
        >
            <Helmet>
                <title>{cateringEventFormat?.name}</title>
                <meta name="description" content={richTextToString(cateringEventFormat?.description)} />
                <meta property="og:title" content={cateringEventFormat?.name} />
            </Helmet>
            <BlockHeader
                title={cateringEventFormat?.name || ''}
                description={cateringEventFormat?.description || []}
                imageSrc={cateringEventFormat?.image?.url || ''}
            />
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="НЕ МОЖЕТЕ ОПРЕДЕЛИТЬСЯ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            <CateringEventFormatPageMainCateringEventsList
                padding="2rem"
                cateringEvents={cateringEvents}
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
            />
        </Flex>
    );
};
